import { createAction, props } from '@ngrx/store';
import { CountryInfo } from '@sharedModule/models/country.model';

export const loadSourceCountry = createAction(
  '[Source Country] Load Source Country',
  props<{ payload?: { partner_id?: number } }>()
);

export const loadSourceCountrySuccess = createAction(
  '[Source Country] Load Source Country Success',
  props<{ sourceCountries: CountryInfo[] }>()
);

export const loadSourceCountryFailure = createAction(
  '[Source Country] Load Source Country Failure',
  props<{ error: string }>()
);

export const deleteSourceCountry = createAction(
  '[Source Country] Delete Source Country',
  props<{ srcCountryName: string }>()
);
